function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import GridParagraphWithImageFieldsConfig from "segments/desktop/core-components/grid-paragraph-with-image/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";
import { BACKGROUND_COLOR_OPTIONS } from "segments/segments-service";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Sliding Card",
    fields: _object_spread_props(_object_spread({}, ThemeConfig), {
        cardsToShow: {
            type: FIELD_TYPES.TEXT,
            label: "Number of cards to show in view"
        },
        cardColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Card color",
            possibleColors: [
                ...BACKGROUND_COLOR_OPTIONS,
                "transparent"
            ]
        },
        cardInnerPadding: {
            type: FIELD_TYPES.TEXT,
            label: "Card paragraph padding"
        },
        isFullScreen: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Is full screen"
        },
        borderColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Border color",
            possibleColors: [
                ...BACKGROUND_COLOR_OPTIONS
            ]
        },
        arrowsColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Arrows color"
        },
        cards: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                label: "Sliding Card",
                fields: GridParagraphWithImageFieldsConfig
            }
        }
    })
};
